// TODO: this functino has a bug in text direction
export const getBeutifiedText = (text = '', limit = 0, rtl) => {
  if (text && text?.length > limit) {
    if (rtl) return text.substring(0, limit) + '...';
    return '...' + text.substring(0, limit);
  }
  return text;
};

// if you want to replace keys with values pass key and value arguments as array,
// otherwise just pass single string for each.
export const replaceKeyWithValue = (text = '', key = '', value = '') => {
  const splittedArray = text.split('#');

  if (Array.isArray(key) && Array.isArray(value)) {
    // TODO: need to implementation
    return splittedArray.join('');
  }

  splittedArray[1] = value;

  return splittedArray.join('');
};

export const capitalizeFirstLetter = (str) => {
  if (typeof str !== 'string' || str.length === 0) {
    // If the input is not a non-empty string, return an empty string
    return '';
  }

  // Capitalize the first letter and concatenate the rest of the string
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toEnDigit = (s) => {
  return s.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (a) {
    return a.charCodeAt(0) & 0xf;
  });
};

export const convertPersianDigitsToEnglishDigits = (input) => {
  const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  return input.replace(/[۰-۹]/g, (match) => persianNumbers.indexOf(match));
};
